import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { show as showDrawerLeft } from '../../redux/slices/Drawer/drawerLeft'
import { activated, verificated } from '../../redux/slices/Auth/login'
import { Stack, Button, Toolbar, IconButton, Typography } from '@mui/material'
import { Tooltip } from '@mui/material'
import MuiAppBar from '@mui/material/AppBar'
import AccountMenu from '../AccountMenu/AccountMenu'
import { isUserVerify } from '../../services'
import Breadcrumb from '../Breadcrumb'

import styledComp from '@emotion/styled'
import { styled } from '@mui/material/styles'
import MenuIcon from '@mui/icons-material/Menu'

import logo_unl from '../../assets/images/logo_unl_short.png'
import logo_cif from '../../assets/images/logo_cif_2.png'
import logo_cis from '../../assets/images/logo_cis_2.png'
import logo_dir from '../../assets/images/Direccion_investigacion.png'

const HEIGHTBORDER = '5px'
const LogosContainer = styledComp.div`
  height: 36px;
`
const shadow = `
0px 2px 4px -1px rgb(0 0 0 / 30%), 
0px 4px 5px 0px rgb(0 0 0 / 0%), 
0px 1px 10px 0px rgb(0 0 0 / 15%)
`

const AppBarMenu = ({ authenticated }) => {
  const dispatch = useDispatch()
  let navigate = useNavigate()
  const _state = useSelector(state => state.drawerLeft)
  const { visible } = useSelector(state => state.login)
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth)
  const { statusData, statusHeaders } = useSelector(state => state.report)

  const handleOpenCloseDrawerLeft = () => {
    dispatch(showDrawerLeft(!_state.open))
  }

  const handleClickLogin = () => {
    dispatch(showDrawerLeft(false))
    dispatch(activated(!visible))
  }

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: prop => prop !== 'open',
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: _state.drawerWidth,
      width: `calc(100% - ${_state.drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }))

  const styleAppBar = {
    height: _state.drawerHeight,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    boxShadow: shadow,
    borderBottom: `${HEIGHTBORDER} solid var(--color-blue)`,
  }

  const styleToolbar = {
    minHeight: `calc(${_state.drawerHeight} - ${HEIGHTBORDER})`,
    paddingLeft: '0px',
    paddingRight: '16px',
  }

  React.useEffect(() => {
    if (Boolean(authenticated?.auth)) return
    const tokenLocal = window.localStorage.getItem('arbolQR_Token')
    if (Boolean(tokenLocal))
      isUserVerify(`Bearer ${tokenLocal}`)
        .then(userLocal => {
          if (userLocal?.auth) dispatch(verificated(userLocal))
          else {
            window.localStorage.removeItem('arbolQR_Token')
            navigate('/', { replace: true })
          }
        })
        .catch(err => console.log('err :>> ', err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    function handleWindowResize() {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleWindowResize)
    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  return (
    <AppBar
      position="fixed"
      color="transparent"
      component="nav"
      sx={styleAppBar}
      open={_state.open}>
      <Toolbar style={styleToolbar}>
        <IconButton
          color="inherit"
          onClick={handleOpenCloseDrawerLeft}
          edge="start"
          sx={{
            mr: 1,
            ml: 0,
            ...(_state.open && { display: 'none' }),
            '&:hover': {
              bgcolor: 'var(--color-blue-light)',
            },
          }}
          disabled={statusHeaders === 'succeeded' && statusData === 'succeeded'}>
          <MenuIcon fontSize="small" />
        </IconButton>
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1, display: { xs: 'block', sm: 'block' } }}>
          <LogosContainer
            style={{
              display: !_state.open ? 'block' : 'none',
              height: `calc(${_state.drawerHeight} - 1vh)`,
            }}>
            <Tooltip title={'UNL'} placement="bottom">
              <img
                src={logo_unl}
                alt="logo-unl"
                height="100%"
                style={{ paddingRight: '12px' }}
              />
            </Tooltip>
            {windowWidth >= 465 && (
              <Tooltip title={'FORESTAL'} placement="bottom" sx={{ mb: 4 }}>
                <img
                  src={logo_cif}
                  alt="logo-cif"
                  height="100%"
                  style={{
                    paddingTop: '2px',
                    paddingBottom: '4px',
                    paddingRight: '12px',
                  }}
                />
              </Tooltip>
            )}
            {windowWidth >= 580 && (
              <Tooltip title={'COMPUTACIÓN'} placement="bottom">
                <img
                  src={logo_cis}
                  alt="logo-cis"
                  height="100%"
                  style={{
                    paddingTop: '2px',
                    paddingBottom: '4px',
                    paddingRight: '4px',
                  }}
                />
              </Tooltip>
            )}
            {windowWidth >= 390 && (
              <Tooltip title={'DIRECCIÓN DE INVESTIGACIÓN'} placement="bottom">
                <img
                  src={logo_dir}
                  alt="logo-direccion-investigacion"
                  height="90%"
                  style={{
                    paddingRight: '4px',
                    paddingBottom: '4px',
                  }}
                />
              </Tooltip>
            )}
          </LogosContainer>
        </Typography>
        <Stack direction="row" sx={{ alignItems: 'center' }}>
          <Breadcrumb authenticated={authenticated} windowWidth={windowWidth} />
          {!authenticated?.auth ? (
            <Button
              variant="contained"
              onClick={handleClickLogin}
              sx={{ backgroundColor: '#004280', fontWeight: 600, fontSize: '0.7rem' }}>
              Login
            </Button>
          ) : (
            <AccountMenu user={authenticated?.user} windowWidth={windowWidth} />
          )}
        </Stack>
      </Toolbar>
    </AppBar>
  )
}
export default AppBarMenu
